import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Props from './DiscountsSummaryComponent';
import FormattedCurrency from '@s/FormattedCurrency';
import Translation from '../../../../shared/Translation';
import { deDuplicateDiscountCoupons } from '../../coupon/helpers/coupon';
import { connect } from 'react-redux';

class DiscountsSummary extends Component<Props> {
  render() {
    let discountTypeIds = [2, 7];
    let discountCouponsOnly = this.props.coupon.couponData.filter(couponEntry =>
      discountTypeIds.includes(couponEntry.coupon_type)
    );
    if (!this.props.hasAutoCoupons && discountCouponsOnly.length === 0) {
      return null;
    }

    return (
      <table className="fees-table">
        <thead>
          <tr>
            <th>
              <Translation>{'checkout__discounts'}</Translation>
            </th>
            <th />
          </tr>
        </thead>
        <tbody>{this.getDiscountsRow(discountCouponsOnly)}</tbody>
      </table>
    );
  }

  getDiscountsRow = discountCouponsOnly => {
    if (this.props.hasAutoCoupons && this.props.coupon.autoCouponAmount !== '') {
      var autoCouponLine = (
        <tr key="autoDiscount" className="discount__line">
          <td className="fees-table__charge">
            <Translation>{'checkout__auto_discount'}</Translation>
          </td>
          <td className="cart-ticket__subtotal">
            (<FormattedCurrency>{this.props.coupon.autoCouponAmount}</FormattedCurrency>)
          </td>
        </tr>
      );
    }

    let discountCouponLine = null;

    if (discountCouponsOnly.length) {
      const deDuppedDiscounts = deDuplicateDiscountCoupons(discountCouponsOnly);
      discountCouponLine = Object.values(deDuppedDiscounts).map((couponData, couponIndex) => (
        <tr key={`${couponData.coupon_name}-${couponIndex}`} className="discount__line">
          <td className="fees-table__charge">{couponData.coupon_name}</td>
          <td className="cart-ticket__subtotal">
            (<FormattedCurrency>{couponData.amount}</FormattedCurrency>)
          </td>
        </tr>
      ));
    }
    if (this.props.chargeDeliveryFee &&  this.props.deliveryFee) {
        let deliveryDiscount =  <tr key= {"delivery_fee_discount"} className="discount__line">
                                    <td className="fees-table__charge">Delivery Fee Discount</td>
                                    <td className="cart-ticket__subtotal"> (<FormattedCurrency>{this.props.deliveryFee}</FormattedCurrency>)
                                    </td>
                                </tr>
        discountCouponLine = [...discountCouponLine, deliveryDiscount];
    }

    return [
      discountCouponLine ? discountCouponLine : <tr key="auto" />,
      autoCouponLine ? autoCouponLine : <tr key="discount" />
    ];
  };
}

DiscountsSummary.propTypes = {
  coupon: PropTypes.object,
  currencySymbol: PropTypes.string,
  hasAutoCoupons: PropTypes.bool
};

const mapStateToProps = state => {
    return {
        deliveryFee: state.delivery?.price?.amount,
        chargeDeliveryFee: state.reservation?.noDeliveryFee,
    }
}
export default connect(mapStateToProps)(DiscountsSummary);